/**
 * Скрипт обновляет иконку корзины когда товар положили в корзину
 * и совершили возврат на предыдущую страницу через кнопку браузера "Назад".
 */
try {
    let isHistory = false
    window.addEventListener('pageshow', () => {
        if (isHistory) {
            BX.ready(() => {
                BX.ajax.insertToNode(BX.message('SITE_DIR') + 'ajax/upd_cart.php', 'topCartCnt')
            })
        }
        isHistory = true
    })

    /**
     * Подписка на событие ниже нужно, что бы в корзине во время удаления товаров автоматически обновлялась иконка корзины.
     */
    BX.ready(() => {
        BX.addCustomEvent('OnBasketChange', () => {
            BX.ajax.insertToNode(BX.message('SITE_DIR') + 'ajax/upd_cart.php', 'topCartCnt')
        })
    })
} catch (error) {
    console.warn(error);
}